import { Skeleton, useMediaQuery } from "@mui/material";
import clsx from "clsx";
import he from "he";
import moment from "moment/moment";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Background } from "../../assets/home-hero-background.svg";
import { ReactComponent as Leaves } from "../../assets/home-hero-leaves.svg";
import { ReactComponent as ClockIcon } from "../../assets/clockIcon.svg";
import Button from "../../button/block.js";
import { displayFormat, stripTags } from "../../shared/tools.js";
import style from "./style.module.scss";

export const Slide = ({ post, isExtraSlide }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const isMobile = useMediaQuery("(max-width: " + style.mobileBreakpoint + ")");

  // React i18next
  const { t } = useTranslation();

  useEffect(() => {
    let imageUrl = post.thumbnail?.url || post.image?.url;
    if (imageUrl) {
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => setImageLoaded(true);
      img.onerror = () => {
        setImageLoaded(true);
      };
    }
  }, [post]);

  return (
    <div className={clsx(style.block, isExtraSlide && style.extraSlide)}>
      <div className={style.content}>
        <Background className={style.background} />

        <div className={style.topContent}>
          {isMobile && isExtraSlide
            ? null
            : post.cat && (
                <a href={post.catLink} className={style.category}>
                  {he.decode(stripTags(post.cat))}
                </a>
              )}

          <div className={style.titleContainer}>
            <a href={post.link}>
              <p className={style.title}>{post.title}</p>

              <p className={style.excerpt}>
                {post.excerpt && he.decode(stripTags(post.excerpt))}
              </p>
            </a>
          </div>

          <Button
            text={t("Read More")}
            link={post.link}
            showInspector={false}
            className={style.button}
          />
        </div>

        {isMobile && isExtraSlide ? null : (
          <div className={style.bottomContent}>
            <p className={style.authorDate}>
              <span className={style.bold}>{post.author}</span>

              <span>
                {t("on") + " " + moment(post.date).format(displayFormat())}
              </span>
            </p>

            <div className={style.line} />

            <div className={style.readingTime}>
              <ClockIcon className={style.clockIcon} />

              <p className={style.readingTime}>
                {post.reading_time + " " + t("min read")}
              </p>
            </div>
          </div>
        )}

        {isMobile && isExtraSlide ? null : <Leaves className={style.leaves} />}

        {isMobile && isExtraSlide ? null : (
          <div className={style.innerBorder} />
        )}
      </div>

      {isMobile && isExtraSlide ? null : (
        <div className={style.image}>
          {!imageLoaded && (
            <Skeleton
              className={style.skeleton}
              variant="rectangular"
              animation="wave"
            />
          )}

          {post.thumbnail?.url ? (
            <img
              src={post.thumbnail.url}
              alt={post.thumbnail.alt || post.thumbnail.title}
              style={{ display: imageLoaded ? "block" : "none" }}
              loading="lazy"
            />
          ) : (
            post.image && (
              <img
                src={post.image.url}
                alt={post.image.alt || post.image.title}
                style={{ display: imageLoaded ? "block" : "none" }}
                loading="lazy"
              />
            )
          )}
        </div>
      )}
    </div>
  );
};

export default Slide;
